export default __webpack_public_path__ + "static/media/limb_big.c5be8913.webp";